/**
 * MōMA • Pokè — utilities SEO.
 *
 * Espone la costante SITE_URL (canonical origin) e helper per costruire URL assoluti.
 *
 * SITE_URL viene letto da REACT_APP_PUBLIC_SITE_URL (build-time). Se assente,
 * fallback su window.location.origin (runtime) o su https://www.momapoke.com.
 */

const FALLBACK = 'https://www.momapoke.com';

function resolveSiteUrl() {
  const fromEnv =
    (typeof process !== 'undefined' &&
      process.env &&
      process.env.REACT_APP_PUBLIC_SITE_URL) ||
    '';
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return FALLBACK;
}

export const SITE_URL = resolveSiteUrl();

export function absoluteUrl(pathname = '/') {
  if (!pathname) return SITE_URL;
  if (/^https?:\/\//i.test(pathname)) return pathname;
  const p = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${SITE_URL}${p}`;
}

export const DEFAULT_SEO = {
  siteName: 'MōMA • Pokè',
  title: 'MōMA • Pokè — Poke Bowl a Catania | Delivery & Ritiro',
  description:
    'Ordina online le migliori poke bowl a Catania. Componi la tua bowl, scegli tra ricette firmate, consegna a domicilio o ritiro in negozio. Pre-ordini e codici sconto disponibili.',
  image: '/icon-512.png',
  locale: 'it_IT',
  twitterCard: 'summary_large_image',
};
